import React from 'react';
import { t } from '@lingui/macro';

import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import useBrandSpecificPets from '@rover/shared/js/hooks/useBrandSpecificPets';
import { PetType } from '@rover/types/src/Pet';

import SkillsList from './SkillsList';

const SkillsByPetType = ({ info }: { info: EnhancedPersonSitterProfile }): JSX.Element => {
  const availablePets = useBrandSpecificPets();
  return (
    <>
      {availablePets.some((petType) => petType === PetType.DOG || petType === PetType.PUPPY) && (
        <SkillsList attributes={info.attributes} heading={t`Dog skills`} />
      )}
      {availablePets.some((petType) => petType === PetType.CAT) && (
        <SkillsList attributes={info.catAttributes} heading={t`Cat skills`} />
      )}
    </>
  );
};

export default SkillsByPetType;
